@if (rideCondition) {
  <div class="map-point-popup">
    <div class="display-flex-container">
      @if (rideCondition.name) {
        <div id="name" class="name">
          <svg-icon
            src="/assets/icons/condition.svg"
            [svgClass]="`${rideCondition.name | removewhitespace | lowercase} condition`"
            [svgAriaLabel]="rideCondition.name"
            i18n-svgAriaLabel
          /><span>{{ rideCondition.name }}</span>
        </div>
      }
      <div id="conditionReportedTime" class="flex-1 helper-secondary-text helper-align-right">
        {{ reportedTime }}
      </div>
    </div>

    @if (rideCondition.description) {
      <div id="conditionDescription">{{ rideCondition.description }}</div>
    }

    <div id="conditionReportedRider" class="helper-secondary-text reported-by">
      <span i18n>Reported by </span>{{ rideCondition.reportedByRider }}
    </div>

    @if (shouldShowReportAbuseLink && (isAuthenticated$ | async)) {
      <div class="report-abuse">
        <a id="reportAbuse" class="helper-secondary-text" href="javascript:void(0);" (click)="reportAbuse()" i18n
          >Report Abuse</a
        >
      </div>
    }
  </div>
}
